<template lang="pug">
#img-viewer
  ImageViewer(v-if="show" :z-index="zIndex" :initial-index="index" :on-close="closeImgHandler" :url-list="urlList")
</template>
<script>
import ImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: { ImageViewer },
  props: {
    urlList: { default: () => [], type: Array },
    index: { default: 0, type: Number },
    zIndex: { default: 0, type: Number },
    onClose: { default: undefined, type: [Function, undefined] }
  },
  data() {
    return { show: true };
  },
  methods: {
    closeImgHandler() {
      const { resolve, onClose, urlList } = this;
      this.show = false;
      if (onClose) onClose(urlList);
      this.$nextTick(() => {
        resolve();
        this.$destroy();
      });
    }
  }
};
</script>
